// Initialize the WeChatModal class when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", () => {
    new WeChatModal();
});

class WeChatModal {
    constructor() {
        this.init();
    }

    init() {
        // Attach event listeners to footer links with href containing "wechat"
        const weChatLinks = document.querySelectorAll('footer a[href*="wechat"]');

        // Exit early if no WeChat links are found
        if (weChatLinks.length === 0) {
            return;
        }

        weChatLinks.forEach(link => {
            link.addEventListener("click", this.preventDefaultAction);
            link.addEventListener("mouseover", (event) => this.showImage(event, link));
        });

        // Close the image container when clicking outside
        document.addEventListener("click", (event) => this.closeImageOnClickOutside(event));
    }

    preventDefaultAction(event) {
        event.preventDefault();
    }

    showImage(event, link) {
        // Find the first div parent of the trigger element
        let parentDiv = link.closest("div");
        if (!parentDiv) return;

        // Check if the image container already exists to avoid duplicates
        let imageContainer = parentDiv.querySelector(".wechat-image-container");
        if (!imageContainer) {
            // Create the div element for the image
            imageContainer = document.createElement("div");
            imageContainer.className = "wechat-image-container";
            imageContainer.innerHTML = `
                <img src="/globalassets/home/footer-icons/wechat_qr_code.jpg" width="258" height="258" />
            `;

            // Append the div to the first div parent
            parentDiv.appendChild(imageContainer);

            // Apply initial styles
            imageContainer.style.position = "absolute";
            imageContainer.style.opacity = "0";
            imageContainer.style.transition = "opacity 0.3s ease, transform 0.3s ease";
        }

        // Calculate the position of the image container
        const linkRect = link.getBoundingClientRect();
        const parentRect = parentDiv.getBoundingClientRect();
        const offsetY = 20; // 20px above

        // Set the position of the image container
        imageContainer.style.right = 0;
        imageContainer.style.top = `${linkRect.top - parentRect.top - offsetY - imageContainer.offsetHeight}px`;

        // Show the image with a fade-in effect
        requestAnimationFrame(() => {
            imageContainer.style.opacity = "1";
        });
    }

    closeImageOnClickOutside(event) {
        // Close the image container if clicking outside of it
        const openContainers = document.querySelectorAll(".wechat-image-container");
        openContainers.forEach(container => {
            if (!container.contains(event.target) && !container.previousElementSibling.contains(event.target)) {
                container.style.opacity = "0";
            }
        });
    }
}